import { useEffect, useState } from 'react';
import { presenceApi } from '../api/client';

/**
 * "Hozir shu yerda nechta odam bor".
 *
 * Har 30 soniyada bitta so'rov: u ham puls ("men shu yerdaman"), ham
 * javob (sanoq). Ikkitasini ajratish keraksiz — sanoq baribir har puls
 * hisoblanadi.
 *
 * Xatolar JIM yutiladi va bu ataylab: onlayn sanoq — bezak, u ishlamay
 * qolgani uchun o'quvchiga toast chiqarish yoki darsni to'sib qo'yish
 * mumkin emas. Tarmoq tiklansa keyingi puls o'zi tuzatadi.
 */
export function usePresence(
  courseId: string | null | undefined,
  lessonId?: string | null,
): { course: number; lesson: number } {
  const [count, setCount] = useState({ course: 0, lesson: 0 });

  useEffect(() => {
    if (!courseId) {
      setCount({ course: 0, lesson: 0 });
      return;
    }

    let alive = true;

    const ping = async () => {
      try {
        const r = await presenceApi(courseId, lessonId ?? undefined);
        if (alive) setCount({ course: r.course ?? 0, lesson: r.lesson ?? 0 });
      } catch {
        /* jim — pastdagi izohga qarang */
      }
    };

    void ping();
    const id = setInterval(ping, 30_000);

    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [courseId, lessonId]);

  return count;
}
